import { ApolloProvider } from '@nerdwallet/apollo';
import getApolloServer from '@nerdwallet/apollo/server';
import getNerdwalletApolloClient from '@nerdwallet/apollo/client';

import apolloOptions from '../apollo/apollo-options';

export const getApolloClient = (options: object = {}) => {
  const optionsMerged = { ...apolloOptions, ...options };
  return typeof window === 'undefined'
    ? getApolloServer(optionsMerged)
    : getNerdwalletApolloClient(optionsMerged);
};

type Props = {
  children?: any;
};

const ApolloWrapper: React.FC<Props> = ({ children }) => {
  const apolloClient = getApolloClient();

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

export default ApolloWrapper;
